export default __webpack_public_path__ + "static/media/single-project-page-02-img1.2250d84d.png";